import RingPager from '@jetbrains/ring-ui/components/pager/pager'
import classNames from 'classnames'
import {memo} from 'react'

import {
  PAGE_QUERY_PARAM_NAME,
  DEFAULT_PAGE_SIZE,
  DEFAULT_VISIBLE_PAGES_LIMIT,
} from './PagerNew.consts'
import type {PagerProps} from './PagerNew.types'

import styles from './PagerNew.css'

function PagerNew({
  className,
  show,
  currentPage,
  openTotal,
  pageSize = DEFAULT_PAGE_SIZE,
  visiblePagesLimit = DEFAULT_VISIBLE_PAGES_LIMIT,
  total,
  changeCurrentPage,
}: PagerProps) {
  const getTotal = () => {
    // With openTotal, show the last page as ...
    const adjustedTotal = openTotal ? total - pageSize : total
    // Always show the requested page
    return Math.max(currentPage * pageSize, adjustedTotal)
  }

  const generateHref = (page: number) => {
    const url = new URL(window.location.href)
    url.searchParams.delete(PAGE_QUERY_PARAM_NAME)
    url.searchParams.append(PAGE_QUERY_PARAM_NAME, page.toString())
    return url.href
  }

  if (!show) {
    return null
  }

  return (
    <RingPager
      className={classNames(className, styles.pager)}
      hrefFunc={generateHref}
      total={getTotal()}
      openTotal={openTotal}
      currentPage={currentPage}
      pageSize={pageSize}
      visiblePagesLimit={visiblePagesLimit}
      onPageChange={changeCurrentPage}
      onLoadPage={changeCurrentPage}
      disablePageSizeSelector
    />
  )
}

export default memo(PagerNew)
